import PuxButton from "../../../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";
import TemplateAdminFunktionenBoxItem from "../TemplateAdminFunktionenBoxItem/TemplateAdminFunktionenBoxItem.vue";

// @vue/component
export default {
  name: "TemplateAdminFunktionenBoxGroup",
  components: {
    PuxButton,
    PuxTranslate,
    TemplateAdminFunktionenBoxItem,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    groupIndex: {
      type: Number,
      required: true,
    },
    groupsAndFunktionenNamesHiddenWithSearch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isVisible() {
      return !this.groupsAndFunktionenNamesHiddenWithSearch.groupNames[this.group.name];
    },

    iconToggle() {
      return this.isOpen ?
        "chevron-up" :
        "chevron-down";
    },

    idToggleButton() {
      return `template_funktionen_group_btn_${ this.groupIndex }`;
    },

    idContent() {
      return `template_funktionen_group_content_${ this.groupIndex }`;
    },

    tooltipToggleButton() {
      return this.isOpen ? "_BTN_ASIDE_RIGHT_BOX_TOGGLE_CLOSE_" : "_BTN_ASIDE_RIGHT_BOX_TOGGLE_OPEN_";
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
